import packageJson from "../../package.json";

export const environment = {
  production: true,
  development: false,
  version: packageJson.version,
};
